export const EXPORT_RANGE_PRESETS = [
  { value: 'last_month', label: 'Last month' },
  { value: 'last_3_months', label: 'Last 3 months' },
  { value: 'year_to_date', label: 'Year to date' },
  { value: 'all_time', label: 'All time' },
] as const;

type PresetKey = (typeof EXPORT_RANGE_PRESETS)[number]['value'];

export type ExportRangePreset = PresetKey | 'custom';

/** Inclusive `YYYY-MM-DD` bounds; an absent bound is unbounded that way. */
interface ExportDateRange {
  dateFrom?: string;
  dateTo?: string;
}

export interface ExportRequest extends ExportDateRange {
  preset: ExportRangePreset;
}

/**
 * The instant's UTC calendar day. The export API compares bounds against
 * `TruncDate(..., tzinfo=utc)`, so a local day would disagree with the CSV's
 * own Date column at either end.
 */
export const toUtcDay = (date: Date): string => date.toISOString().slice(0, 10);

export const resolvePresetRange = (
  preset: PresetKey,
  today: Date,
): ExportDateRange => {
  const year = today.getUTCFullYear();
  const month = today.getUTCMonth();
  // Day 0 of this month is the last day of the previous one.
  const endOfLastMonth = toUtcDay(new Date(Date.UTC(year, month, 0)));

  switch (preset) {
    case 'all_time':
      return {};
    case 'year_to_date':
      return {
        dateFrom: toUtcDay(new Date(Date.UTC(year, 0, 1))),
        dateTo: toUtcDay(today),
      };
    case 'last_month':
      return {
        dateFrom: toUtcDay(new Date(Date.UTC(year, month - 1, 1))),
        dateTo: endOfLastMonth,
      };
    case 'last_3_months':
      return {
        dateFrom: toUtcDay(new Date(Date.UTC(year, month - 3, 1))),
        dateTo: endOfLastMonth,
      };
  }
};
